/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BiometricsProvider {
  IDWALL = 'IDWALL',
  SAFFE = 'SAFFE',
  MANUAL = 'MANUAL',
}
